import {
  onConnect,
  reatomAsync,
  sleep,
  withAbort,
  withConcurrency,
} from '@reatom/framework'

import { AsyncStateN as _ } from '@blade/std-lib'
import { environmentAtom } from '@root/shared'

import { suggestedGasSettingsReatom } from './suggested-gas-settings'

export const suggestedGasSettingsPollingReatom = () => {
  const { loadSuggestedSettingsAction, suggestedSettingsStateAtom } =
    suggestedGasSettingsReatom()

  const startGasSettingsPollingAction = reatomAsync(async (ctx) => {
    const { gasPricesRefreshInterval } = ctx.get(environmentAtom)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while (true) {
      await ctx.schedule(() => loadSuggestedSettingsAction(ctx))
      await ctx.schedule(() => sleep(gasPricesRefreshInterval * 1000))
    }
    // eslint-disable-next-line no-unreachable
    return undefined
  }, 'startGasSettingsPollingAction').pipe(withAbort(), withConcurrency())

  onConnect(suggestedSettingsStateAtom, (ctx) => {
    startGasSettingsPollingAction(ctx)

    return () => {
      startGasSettingsPollingAction.abort(ctx)
    }
  })

  return {
    suggestedSettingsStateAtom,
  }
}

export type SuggestedGasSettingsPollingReatom = ReturnType<
  typeof suggestedGasSettingsPollingReatom
>
